/**
 * @file        loadingOverlay.component.ts
 * @description App-level loading overlay (same look as the login spinner)
 * @version     1.0.0
 * @author      Boris Veits
 * @copyright   Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *              Property of MindShare HDV LLC.  This file cannot be used or
 *              altered in anyway without expressed written permission from
 *              MindShare HDV LLC.
 */
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from
    '@angular/material/progress-spinner';

import { LoadingService } from '@app/service/loading.service';

@Component
({
    selector: 'app-loading-overlay',
    standalone: true,
    imports: [
        AsyncPipe,
        NgIf,
        MatProgressSpinnerModule
    ],
    template: `
        <div class="cy-loading-overlay"
             *ngIf="loadingSrv.loading$ | async"
             role="status" aria-live="polite" aria-busy="true">
            <div class="cy-loading-center">
                <mat-spinner class="cy-loading-spinner"
                             aria-hidden="true">
                </mat-spinner>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [`
        .cy-loading-overlay
        {
            position: fixed;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgba(15, 20, 32, 0.45);
            z-index: 2000;
        }

        .cy-loading-center
        {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
        }

        :host ::ng-deep .cy-loading-spinner circle
        {
            stroke: var(--cy-accent);
        }
    `]
})
class LoadingOverlayComponent
{
    /**
     * @desc   - inject the shared loading state
     * @access - public
     * @param  - loadingSrv : pending work tracker
     * @return -
     */
    constructor
    (
        public loadingSrv: LoadingService
    )
    {
    }
}

export { LoadingOverlayComponent };
